import React from "react";
import { SectionHeading } from "../SectionHeading";
import { CtaButton } from "../CtaButton";
import { situations } from "../../data/content";
export function Situations() {
  return <section className="bg-brand-950 px-4 py-16 md:py-24" aria-labelledby="situations-title" data-id="element-249" data-mp="2tfcbgshavx2v">
      <div className="mx-auto max-w-5xl" data-id="element-250" data-mp="2ogr7qj2uav9o">
        <SectionHeading dark title={<span id="situations-title" data-id="element-252" data-mp="2jheoe8b6g6bu">Do any of these situations sound familiar?</span>} subtitle={<>
              If you answer <strong className="text-gold" data-id="element-253" data-mp="2eha7wia9rblm">YES</strong> to even one, I created this system for you.
            </>} data-id="element-251" data-mp="2ofpxggtnect0" />

        <ul className="mt-10 grid gap-3 md:grid-cols-2 md:gap-4" data-id="element-254" data-mp="2aiuadkgkakty">
          {situations.map(({
          icon: Icon,
          text
        }) => <li key={text} className="flex gap-4 rounded-2xl bg-white/[0.07] p-5 ring-1 ring-white/10" data-id="element-255" data-mp="8pd2cfoirhyo">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gold text-brand-950" data-id="element-256" data-mp="3qjqerovrz0m">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-257" data-mp="134tubx5jzf5d" />
              </span>
              <p className="text-[16px] leading-relaxed text-white" data-id="element-258" data-mp="183y0sg13eys0">{text}</p>
            </li>)}
        </ul>

        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-259" data-mp="u56pt2hj1t83">
          <p className="text-lg leading-relaxed text-brand-100" data-id="element-260" data-mp="z3i3joay0nvl">And it shouldn't have to feel this complicated.</p>
          <p className="mt-4 font-serif text-2xl font-extrabold leading-snug text-white md:text-3xl" data-id="element-261" data-mp="1mtcbbrgenm8z">
            The problem isn't necessarily your knowledge. It may be that no one ever gave you a{" "}
            <em className="text-gold" data-id="element-262" data-mp="1d3suerc962gr">simple visual system</em> for connecting everything you already know.
          </p>
        </div>

        <div className="mt-10" data-id="element-263" data-mp="1i12ponmbp8ci">
          <CtaButton label="I want the system" data-id="element-264" data-mp="1i013po3rr1g0" />
        </div>
      </div>
    </section>;
}